export default __webpack_public_path__ + "static/media/guidelines-2.e520fd36.png";